import { ComponentConfig } from '@measured/puck';

import { Header as HeaderComponent, HeaderProps } from '../../../../components/atoms/header/header';

type HeaderBlockProps = {
  readonly anchor?: string;
  readonly text: React.ReactNode;
  readonly level: HeaderProps['level'];
};

const Header = ({ level, text, anchor }: HeaderBlockProps) => {
  const header = (
    <HeaderComponent id={anchor} level={level}>
      {text}
    </HeaderComponent>
  );

  return header;
};

const HeaderBlock: ComponentConfig<HeaderBlockProps> = {
  defaultProps: {
    text: 'This is a heading',
    level: 'h1',
  },
  fields: {
    text: {
      type: 'text',
    },
    level: {
      type: 'select',
      options: [
        { label: 'H1', value: 'h1' },
        { label: 'H2', value: 'h2' },
        { label: 'H3', value: 'h3' },
        { label: 'H4', value: 'h4' },
        { label: 'H5', value: 'h5' },
      ],
    },
  },
  label: 'Header',
  render: Header,
  resolveFields: ({ props }, { fields }) => {
    return {
      ...fields,
    };
  },
};

export { HeaderBlock };

export type { HeaderBlockProps };
